import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../hoc/AxiosSetting/axios'
import S3FileUpload from 'react-s3';
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance';


export default class compReports extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filenameToview: "",
            data: {},
            data1: {},
            listOfCompanies: {
                orgCode: 0,
                masterAgreementUrl: ""
            },
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedMasterAgreementURL: "",
            submitStatus: true,
            messageforvalidation: "none",
            reporttype: "none",
            reporttype1: "none",

        }
        this.masteragreementUrlInput = React.createRef();
    }
    componentDidMount() {
        axios.get(APIURL + '/api/technicalexpert/get/listtechnicalexperts')
            .then(res => {
                this.setState({ data: res.data.response })
                console.log("res.data.response", res.data.response)
            })
        axios.get(APIURL + '/api/nace/get/nacecodeassignment')
            .then(res => {
                this.setState({ data1: res.data.response })
                console.log("data 1", res.data.response)
            })
    }


    downloadPDF = () => {
        return axios.get(APIURL + '/api/generatepdf/get/initialCompetancetechpdf', {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `InitialcompReports.pdf`
                link.click()
            })

    }

    downloadPDF1 = () => {
      
        return axios.get(APIURL + '/api/generatepdf/get/competancymatrixpdf', {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            },
            data: {
                revisionDate: '12-Mar-22',
                revisionNum: '1'
              }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `CompetancyMatrix.pdf`
                link.click()
            })

    }
    downloadPDF2 = () => {
       
        return axios.get(APIURL + '/api/generatepdf/get/nacecodeassignmentpdf', {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Nacecode.pdf`
                link.click()
            })

    }
    downloadPDF3 = () => {
        return axios.get(APIURL + '/api/generatepdf/get/criteriaForCertpdf', {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Nacecode.pdf`
                link.click()
            })

    }
    render() {

        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ minHeight: "450px" }}>
                                        <div className="row htmlpage">
                                            <div className="col-sm-12">
                                            </div>
                                            <div className="row mt-5">
                                                <div className="col-sm-1" />
                                                <div className="col-sm-5">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={() => { this.downloadPDF() }} style={{width:"70%",height:"100%"}}>Download Initial Tech Report</button>
                                                </div>
                                                {/* <div className="col-sm-5">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={() => { this.downloadPDF1() }}>Download Competancy Matrix Report</button>
                                                </div> */}

                                            </div>
                                            <div className="row mt-5">
                                                <div className="col-sm-1" />
                                                <div className="col-sm-5">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={() => { this.downloadPDF2() }} style={{width:"70%",height:"90%"}}>Download Nace Code Report</button>
                                                </div>
                                              
                                            </div>
                                            {/* <div className="row mt-5">
                                                <div className="col-sm-1" />
                                                
                                                <div className="col-sm-5">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={() => { this.downloadPDF3() }} style={{width:"70%",height:"90%"}}>Download Criteria of Cert</button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </section>

                </div>
            </div>
        )
    }
}